import type { Translations } from '@wix/wix-data-client-types'

export type InterpolationPrefix = '<%=' | '{{' | '{'

export type InterpolationSuffix = '%>' | '}}' | '}'

export type TransformTranslationsOptions = {
  prevSuffix: InterpolationSuffix
  prevPrefix: InterpolationPrefix
  newSuffix: InterpolationSuffix
  newPrefix: InterpolationPrefix
}

export const DEFAULT_TRANSFORM_TRANSLATION_OPTIONS: TransformTranslationsOptions =
  {
    prevPrefix: '{',
    prevSuffix: '}',
    newPrefix: '<%=',
    newSuffix: '%>',
  }

export const transformTranslations = (
  translations: Translations,
  {
    prevPrefix,
    prevSuffix,
    newPrefix,
    newSuffix,
  }: TransformTranslationsOptions = DEFAULT_TRANSFORM_TRANSLATION_OPTIONS,
) =>
  Object.keys(translations).reduce<Translations>((acc, key) => {
    acc[key] = translations[key]
      .split(prevPrefix)
      .join(newPrefix)
      .split(prevSuffix)
      .join(newSuffix)
    return acc
  }, {})
